import { useEffect } from "react";
import { App } from "@capacitor/app";
import { useNavigate } from "react-router-dom";

export const AppUrlListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    App.addListener("appUrlOpen", (event) => {
      try {
        const deepLinkUrl = new URL(event.url);

        // Handle Privy OAuth callback
        if (
          deepLinkUrl.search &&
          deepLinkUrl.searchParams.has("privy_oauth_code") &&
          deepLinkUrl.searchParams.has("privy_oauth_state") &&
          deepLinkUrl.searchParams.has("privy_oauth_provider")
        ) {
          const currentUrl = new URL(window.location.href);
          currentUrl.search = deepLinkUrl.search;
          window.location.assign(currentUrl.toString());
        }

        // Handle Strava OAuth callback
        if (deepLinkUrl.pathname.includes('/strava/callback')) {
          const code = deepLinkUrl.searchParams.get('code');
          const error = deepLinkUrl.searchParams.get('error');
          const state = deepLinkUrl.searchParams.get('state');

          if (error === 'access_denied') {
            navigate('/profile-success?strava=denied');
          } else if (code) {
            // Forward to backend to complete OAuth flow
            const backendUrl = new URL(`${import.meta.env.VITE_API_URL}/api/strava/callback`);
            backendUrl.searchParams.set('code', code);
            if (state) backendUrl.searchParams.set('state', state);

            window.location.href = backendUrl.toString();
          }
        }
      } catch (error) {
        console.error("Failed to parse deep link URL:", error);
      }
    });
  }, [navigate]);

  return null;
};
